var TorsoView = require('backbone-torso/modules/View');
var loadingPerspectiveTemplate = require('./loadingPerspectiveTemplate.hbs');
var screenSizeView = require('./../screen-size/screenSizeView');

/**
 * Perspective to display a loading screen while data is fetched from the server.
 *
 * @class loadingPerspective
 * @static
 */
var LoadingPerspective = TorsoView.extend({
  moduleNamespace: 'loading',
  template: loadingPerspectiveTemplate,

  /**
   * Detect whether it is in default (not large) screen view
   * @method _updateScreenSize
   * @private
   */
  _updateScreenSize: function() {
    var currentScreenIsLargerThanTablet = screenSizeView.currentSizeIsLarger(screenSizeView.SCREEN_SIZES.MEDIUM_LANDSCAPE);
    this.set('isLargeScreen', currentScreenIsLargerThanTablet);
  },

  /**
   * @method initialize
   * @override
   */
  initialize: function() {
    this.listenTo(this.viewState, 'change:isLargeScreen', this.render);
    this.listenTo(screenSizeView, 'change:screenSize', this._updateScreenSize);
    this._updateScreenSize();
  },

  /**
   * @method prepare
   * @override
   */
  prepare: function() {
    var templateContext = TorsoView.prototype.prepare.apply(this);
    var hasPageHeader = this.hasPageHeader;
    var hasSubHeader = this.hasSubHeader;
    var isLargeScreen = this.get('isLargeScreen');
    var showSubHeader = hasSubHeader && isLargeScreen;

    templateContext.showSubHeader = showSubHeader;
    templateContext.showPageHeader = hasPageHeader && !showSubHeader;

    templateContext.hasAside = this.hasAside;
    templateContext.hasPageFooter = this.hasPageFooter;
    return templateContext;
  }
});

module.exports = LoadingPerspective;
